module.exports = __webpack_public_path__ + "svg/symbol-defs.svg";